import { EMAIL_URL, ADMIN_EMAIL, FROM_EMAIL } from "../domain/constant";
import axios from "axios";
export async function email({ to, subject, message, from }) {
  let url = `${EMAIL_URL}?email=${to ? to : ADMIN_EMAIL}&from=${
    from ? from : FROM_EMAIL
  }&message=${encodeURI(message)}&subject=${encodeURI(subject)}&emailsend=true`;
  const image = await axios.get(url);
}
